export const FLEET_COAST_CARD_NAME = {
  AT: 'at.fleet.coast-card',
  DT: 'dt.fleet.coast-card'
};
